import { Col, Dropdown, Row, Text } from 'components';
import { capitalize, theme } from 'lib';
import styled from 'styled-components';

const Image = styled.img`
  width: 30%;
  margin: 8px 0 0;
`;

const options = ['New', 'Rejected', 'Canceled', 'Confirmed', 'Shipped', 'Complete'];

const OrderItem = ({ item, handleChange }) => {
  const singlePrice = item.priceInUSD / item.qty,
    singleDiscounted = item.discountedInUSD / item.qty;

  if (!item) return null;

  return (
    <Row
      marg="24px 0 0"
      pad="16px"
      hasBorder={`1px solid ${theme.GREY_60}`}
      bg={theme.GREY_20}
      // hasRadius='16px'
      between
    >
      <Col>
        <Text med maxWid="280px">
          {item.name}
        </Text>

        <Image src={item.media.length && item.media[0].thumbnail} />

        <Text b2 med marg="8px 0 0">
          QTY: {item.qty}
        </Text>

        <Text b2 med marg="4px 0 0">
          Description: {item.stockDescription}
        </Text>
      </Col>

      <Col noFlex between ht="100%">
        <Col start minWid="200px">
          <Dropdown
            title="Status"
            options={options}
            selected={capitalize(item.status)}
            handleSelect={(opt) => handleChange({ status: opt.toLowerCase() })}
          />
        </Col>

        <Col noFlex end>
          {!!item.discount && (
            <Row noFlex>
              <Text style={{ textDecoration: 'line-through' }} right marg="0 12px 0 0">
                {(singlePrice / 100).toLocaleString(undefined, {
                  style: 'currency',
                  currency: 'USD'
                })}
              </Text>

              <Text bold>{' -' + item.discount} %</Text>
            </Row>
          )}

          <Text right>
            {(singleDiscounted / 100).toLocaleString(undefined, {
              style: 'currency',
              currency: 'USD'
            })}
          </Text>

          <Text right>x{item.qty}</Text>

          <Text right>
            {(item.discountedInUSD / 100).toLocaleString(undefined, {
              style: 'currency',
              currency: 'USD'
            })}
          </Text>
        </Col>
      </Col>
    </Row>
  );
};

export default OrderItem;
